<template>
    <div class="ku-goods-success">
        <div class="top">
            <img class="logo" src="../../assets/thank.png" style="object-fit: cover" alt="thank you">
            <div class="re" v-if="info.order_type === 2">
                <span>充值成功</span>
                <span>当前余额{{ info.money }}元</span>
                <label>返回购物车继续操作</label>
            </div>
            <span v-show="info.order_no" class="number" v-if="info.pack === 1 || info.pack === 2">{{ info.order_no }}</span>
            <span v-show="info.order_no" class="name" v-if="info.pack === 1">取餐号</span>
            <span v-show="info.order_no" class="name" v-if="info.pack === 2">外带取餐号</span>
            <div class="s2" v-if="info.pack === 1 || info.pack === 2">请长按关注公众号</div>
            <div class="s3" v-if="info.pack === 3">预计25-50分钟到达<br>请留意公众号消息推送</div>
            <img class="qrcode" src="../../assets/qrcode.jpg" style="object-fit: cover" alt="qrcode" v-if="info.pack === 1 || info.pack === 2">
        </div>
        <van-button type="info" v-if="info.user_id" @click="onClick">确定</van-button>
    </div>
</template>

<script>
import Vue from 'vue';
import {Button, Image as VanImage} from 'vant';
import {getCookie} from '@/utils/auth'
import {UrlSearch} from "@/utils/fu";

Vue.use(VanImage).use(Button);
    export default {
        name: "index",
        data() {
            return {
                coType: 0,
                shop_id: 0,
                no: '',
                info: [],
                href: {}
            }
        },
        mounted() {
            const s = document.createElement('script');
            s.type = 'text/javascript';
            s.src = 'https://wx.gtimg.com/pay_h5/goldplan/js/jgoldplan-1.0.0.js';
            document.body.appendChild(s);

            this.coType = getCookie('coType');
            this.shop_id = getCookie('shop_id')

            this.href = new UrlSearch();
            this.onLoad();
        },
        methods: {
            onLoad() {
                let that = this
                window.parent.postMessage({'action':'onIframeReady', 'displayStyle': 'SHOW_CUSTOM_PAGE', 'height': 960},'https://payapp.weixin.qq.com');
                this.$API.orderSuccess(that.href).then(res => {
                    return res;
                }).then(res => {
                    that.info = res.data.data;
                    if (that.info.order_type === 2) {
                        window.parent.postMessage({'action':'onIframeReady', 'displayStyle': 'SHOW_CUSTOM_PAGE', 'height': 600},'https://payapp.weixin.qq.com');
                    }
                })
            },
            onClick() {
                if (this.info.order_type === 1) {
                    parent.postMessage({
                        action: 'jumpOut',
                        jumpOutUrl: process.env.VUE_APP_USER_URL + '/order'
                    }, 'https://payapp.weixin.qq.com')
                } else {
                    parent.postMessage({
                        action: 'jumpOut',
                        jumpOutUrl: process.env.VUE_APP_USER_URL + '/goods?shop_id=' + this.info.shop_id
                    }, 'https://payapp.weixin.qq.com')

                }
            },
        },
    }
</script>

<style lang="less" scoped>
.ku-goods-success {
    height: 100%;
    width: 100%;
    position: fixed;
    background: #F7F7F7;
    .top {
        width: 80%;
        height: auto;
        border: 1px solid #F0DAB3;
        border-radius: 15px;
        background: white;
        padding: 30px 15px;
        margin: 30px auto;
        .logo {
            width: 100%;
        }
        .qrcode {
            width: 50%;
        }
        span{
            display: block;
            color: #D42D27;
            &.number {
                font-size: 200px;
                font-weight: bold;
                padding-top: 30px;
            }
            &.name {
                font-size: 50px;
            }
        }
        .s1 {
            .van-button {
                width: 150px;
                height: 50px;
                padding: 5px 20px;
                margin: 30px 5px 0 5px;
                border-radius: 15px;
                background: #E79A30;
                .van-button__text {
                    color: white;
                }
            }
        }
        .s2 {
            font-size: 32px;
            padding: 15px 0;
            font-weight: bold;
            letter-spacing: 2px;
        }
        .s3 {
            font-size: 34px;
            padding: 15px 0;
            letter-spacing: 2px;
        }
        .re {
            span {
                font-size: 50px;
                line-height: 100px;
            }
            label {
                display: inline-block;
                margin-top: 50px;
                padding: 3px 20px;
                font-size: 26px;
                border:1px solid #666;
                border-radius: 10px;
            }
        }
    }
    &>.van-button {
        background: #3C834B;
        border-color: #3C834B;
        width: 185px;
        height: 70px;
        border-radius: 8px;
        font-size: 32px;
    }
}
</style>
